/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useParentAppLock } from "../../contexts/ParentAppLockContext";
import { hapticTap, hapticSelection, hapticSuccess } from "utils/haptics";
import "./ParentBiometricGate.css";

function FingerprintIcon() {
  return (
    <svg viewBox="0 0 24 24" className="ppbg-icon" fill="none" stroke="currentColor" strokeWidth="1.9">
      <path d="M12 3.5a7.5 7.5 0 0 0-7.5 7.5" />
      <path d="M19.5 11A7.5 7.5 0 0 0 12 3.5" />
      <path d="M6.2 13.8v.5A5.8 5.8 0 0 0 12 20.1" />
      <path d="M17.8 13.8a5.8 5.8 0 0 1-5.8 6.3" />
      <path d="M9 10.8a3 3 0 0 1 6 0v2.7a6 6 0 0 1-6 6" />
      <path d="M12 8a3 3 0 0 0-3 3v2.5" />
    </svg>
  );
}

export default function ParentBiometricGate() {
  const {
    unlockNow,
    unlockBusy,
    unlockError,
    refreshLockState,
  } = useParentAppLock();

  const [localError, setLocalError] = useState("");

  useEffect(() => {
    refreshLockState();
  }, [refreshLockState]);


  async function handleUnlock() {
    await hapticSelection();
    setLocalError("");

    const result = await unlockNow();

    if (result?.success) {
      await hapticSuccess();
      return;
    }

    if (result?.message) {
      setLocalError(result.message);
    }
  }

  return (
    <div className="ppbg-wrap">
      <div className="ppbg-backdrop" />

      <div className="ppbg-card">
        <div className="ppbg-icon-wrap">
          <FingerprintIcon />
        </div>

        <p className="ppbg-eyebrow">PresentPlus Parent</p>
        <h1 className="ppbg-title">Unlock your parent app</h1>
        <p className="ppbg-copy">
          Use your device biometric security to continue to your family dashboard.
        </p>

        {localError || unlockError ? (
          <div className="ppbg-error">
            {localError || unlockError}
          </div>
        ) : null}

        <button
          type="button"
          className="ppbg-button"
          onClick={handleUnlock}
          disabled={unlockBusy}
        >
          {unlockBusy ? "Checking…" : "Unlock with biometrics"}
        </button>
      </div>
    </div>
  );
}